import { z } from "zod";

const DeleteInventoryResponseSchema = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
});

export { DeleteInventoryResponseSchema };
export type DeleteInventoryResponse = z.infer<typeof DeleteInventoryResponseSchema>;
